var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 42,
    viewBox: "0 0 39 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 37.6678C1 38.5515 1.35107 39.3991 1.97598 40.024C2.6009 40.6489 3.44846 41 4.33222 41H34.3222C35.206 41 36.0535 40.6489 36.6785 40.024C37.3034 39.3991 37.6544 38.5515 37.6544 37.6678V4.33222C37.6544 3.44846 37.3034 2.6009 36.6785 1.97598C36.0535 1.35107 35.206 1 34.3222 1L1 1.01333V37.6678Z",
    stroke: "#979592",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1778 11.7102L22.9502 17.1684H27.6753C27.9349 17.1632 28.1901 17.2361 28.4078 17.3778C28.6254 17.5194 28.7954 17.7232 28.8958 17.9627C28.9961 18.2022 29.0222 18.4664 28.9705 18.7209C28.9189 18.9754 28.7919 19.2084 28.6061 19.3899L24.2676 23.6596L26.6712 29.1799C26.7764 29.4327 26.7997 29.712 26.7377 29.9787C26.6758 30.2453 26.5318 30.4858 26.3261 30.6663C26.1203 30.8469 25.8631 30.9583 25.5906 30.9849C25.3182 31.0116 25.0442 30.9521 24.8074 30.8149L18.9982 27.5449L13.189 30.8105C12.9522 30.9477 12.6782 31.0072 12.4058 30.9805C12.1333 30.9538 11.8761 30.8424 11.6703 30.6619C11.4645 30.4814 11.3206 30.2409 11.2587 29.9742C11.1967 29.7076 11.22 29.4282 11.3252 29.1755L13.7288 23.6551L9.39029 19.3832C9.2045 19.2018 9.07754 18.9687 9.02588 18.7142C8.97423 18.4597 9.00027 18.1956 9.10062 17.9561C9.20097 17.7166 9.371 17.5128 9.58864 17.3711C9.80627 17.2295 10.0615 17.1565 10.3211 17.1617H15.0462L17.8208 11.7102C17.9341 11.4958 18.1037 11.3164 18.3113 11.1913C18.519 11.0661 18.7569 11 18.9993 11C19.2418 11 19.4796 11.0661 19.6873 11.1913C19.8949 11.3164 20.0645 11.4958 20.1778 11.7102Z",
    stroke: "#979592",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartBox);
export default __webpack_public_path__ + "static/media/startBox.fbf9cc6fef09e814b3e3c174dfa51c72.svg";
export { ForwardRef as ReactComponent };